// hooks/useAuth.js

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useAuth = (navigate, location) => {
  const accessToken = useSelector((state) => state.auth.accessToken);
  const userRole = useSelector((state) => state.auth.role);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Not logged in
    if (!isLoggedIn || !accessToken || !userRole) {
      if (location.pathname !== "/") {
        navigate("/", { replace: true });
      }
    }
    // Logged in but on login page
    else if (location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    }

    setLoading(false);
  }, [accessToken, userRole, isLoggedIn, navigate, location.pathname]);

  return {
    loading,
    isLoggedIn,
    userRole,
    accessToken,
  };
};
